import { useEffect, useState } from "react";
import type { ChatMsg } from "./useChatStream";

export const NOMBRE_HERRAMIENTA: Record<string, string> = { get_snapshot_section: "consultando tu foto", lookup_catalog: "buscando en el catálogo", explain_formula: "revisando la fórmula", simulate: "calculando el escenario", compare_snapshots: "comparando tus fotos" };

/**
 * Qué ve el miembro mientras el asesor todavía no escribe. Reglas que seguimos:
 * respuesta inmediata al enviar (puntos animados), decir en qué fase va (leyendo → pensando → herramientas),
 * poner expectativa de tiempo a los 4 s, y a los 10 y 25 s avisar que sigue trabajando para que no cierre ni reenvíe.
 */
export function Espera({ m }: { m: ChatMsg }) {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 1000); return () => clearInterval(t); }, []);
  const seg = Math.floor((Date.now() - (m.desde ?? Date.now())) / 1000);
  const ultima = m.tools[m.tools.length - 1];
  const fase =
    m.fase === "reintentando" ? `Hay mucha gente con el asesor ahora mismo. Reintento en unos segundos (${m.intento ?? 1} de 2)…`
    : m.fase === "pensando" ? "Pensando en tu caso…"
    : m.fase === "herramientas" ? `${(ultima && NOMBRE_HERRAMIENTA[ultima]) ?? "consultando tus números"}…`.replace(/^./, (c) => c.toUpperCase())
    : "Leyendo tu foto…";
  const aviso = m.fase === "reintentando" ? null : seg >= 25 ? "Sigue en proceso; no cierres la ventana ni reenvíes la pregunta." : seg >= 10 ? "Está tardando un poco más de lo normal. Sigue trabajando." : seg >= 4 ? "Suele tardar entre 5 y 20 segundos." : null;
  return (
    <div className="flex flex-col gap-1 py-0.5" role="status" aria-live="polite">
      <div className="flex items-center gap-2 text-sm text-tinta-suave">
        <span className="inline-flex items-center gap-1" aria-hidden>
          {[0, 150, 300].map((d) => <span key={d} className="h-1.5 w-1.5 animate-bounce rounded-full bg-tinta-suave" style={{ animationDelay: `${d}ms` }} />)}
        </span>
        <span>{fase}</span>
      </div>
      {aviso && <span className="text-xs text-tinta-suave">{aviso}</span>}
    </div>
  );
}
